import { HeaderSection } from '@/components/Common/HeaderSection/HeaderSection';
import { NavigationTabs } from '@/components/Common/NavigationTabs/NavigationTabs';
import { UploadCsvDialog } from '@/components/Product/UploadCSV/Dialog/UploadCSVDialog';
import { CSVProductOperation } from '@/hooks/product/useMassiveUpload';
import TopLevelSectionLayout from '@/layouts/TopLevelSectionLayout/TopLevelSectionLayout';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { useState } from 'react';

export default function ProductDirectory() {
  const [showUploadCsvDialog, setShowUploadCsvDialog] =
    useState<CSVProductOperation>();

  return (
    <TopLevelSectionLayout>
      <HeaderSection
        title="Productos"
        sx={{
          px: { xs: '16px', md: '0px' },
          pb: { xs: '0px', md: '16px' },
        }}
        primaryButton={{
          label: 'Cargar Productos',
          variant: 'contained',
          leftIcon: <FileUploadOutlinedIcon />,
        }}
        onPrimaryButtonClicked={() =>
          setShowUploadCsvDialog(CSVProductOperation.UPLOAD)
        }
        secondaryButton={{
          label: 'Actualizar Productos',
          variant: 'contained',
          leftIcon: <CloudSyncOutlinedIcon />,
        }}
        onSecondaryButtonClicked={() =>
          setShowUploadCsvDialog(CSVProductOperation.UPDATE)
        }
      />
      <NavigationTabs
        links={[
          {
            to: '/admin/products',
            label: 'Todos',
          },
          {
            to: '/admin/products/active',
            label: 'Publicados',
          },
          {
            to: '/admin/products/inactive',
            label: 'Inactivos',
          },
        ]}
      />
      <UploadCsvDialog
        popupType={showUploadCsvDialog}
        closeAction={() => setShowUploadCsvDialog(undefined)}
      />
    </TopLevelSectionLayout>
  );
}
